import { UsageRequest } from '@app/models/feed_usage/FeedUsageRequest';
import {
  UsageTableData,
  UsageResponse,
  UsageApiData,
  UsageTableRow,
  Parameters,
} from '@app/models/feed_usage/FeedUsageResponse';
import { post, get } from './http.api';

export const getUsageData = async (parameters: Parameters): Promise<UsageTableData> => {
  try {
    const { data, status } = await get<any>(
      'feed_ingredient_usages',
      {
        params: parameters,
      },
      true,
    );
    console.log(`Status: ${status}`, `Data:`, data);
    const feedUsages = data?.pr_feed_ingredient_usages?.data || [];

    const feedUsage: UsageTableRow[] = feedUsages.map((usageData: any) => ({
      id: usageData.id,
      year: usageData.year,
      status: usageData.status,
    }));

    return {
      data: feedUsage,
      pagination: {
        current: data.current_page,
        pageSize: data.per_page,
        total: data.total,
      },
    };
  } catch (error: any) {
    console.error('Error fetching Feed Material Usages:', error);
    throw error;
  }
};

export const getAllMaterialUsage = async (): Promise<UsageResponse> => {
  try {
    const { data, status } = await get<UsageResponse>(`feed_ingredient_usages`, undefined, true);
    console.log(`Status: ${status}`, `Data: ${JSON.stringify(data)}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw error;
  }
};

export const getUsageId = async (id: number): Promise<UsageResponse> => {
  try {
    const { data, status } = await get<UsageResponse>(`feed_ingredient_usages/${id}`, undefined, true);
    console.log(`Status: ${status}`, `Data: ${JSON.stringify(data)}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw error;
  }
};

export const storeUsage = async (usageData: UsageRequest) => {
  try {
    const response = await post<any>('feed_ingredient_usages/create', usageData, undefined, true);
    console.log(`Status: ${response.status}`, `Data: ${JSON.stringify(response.data)}`);
    return response.data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw error;
  }
};

export const createUsage = async (): Promise<UsageApiData> => {
  try {
    const { data, status } = await get<UsageApiData>(`feed_ingredient_usages/create`, undefined, true);
    console.log(`Status: ${status}`, `Data: ${data}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw new Error(`Error: ${error.status} - ${error.message}`);
  }
};

export const showUsage = async (id: number) => {
  try {
    const { data, status } = await get<UsageApiData>(`feed_ingredient_usages/${id}`, undefined, true);
    console.log(`Status: ${status}`, `Data: ${data}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw new Error(`Error: ${error.status} - ${error.message}`);
  }
};

export const editUsage = async (id: number) => {
  try {
    const { data, status } = await get<UsageApiData>(`feed_ingredient_usages/${id}/edit`, undefined, true);
    console.log(`Status: ${status}`, `Data: ${data}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw new Error(`Error: ${error.status} - ${error.message}`);
  }
};

export const updateUsage = async (id: number, UpdateUsage: UsageRequest) => {
  try {
    const { data, status } = await post<UsageRequest>(
      `feed_ingredient_usages/${id}/edit`,
      UpdateUsage,
      undefined,
      true,
    );
    console.log(`Status: ${status}`, `Data: ${data}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw new Error(`Error: ${error.status} - ${error.message}`);
  }
};
